<template>
  <div class="the-main">
    <div v-if="isMobileScreen">
      <div ref="height">
        <MobileNavbar />
        <!-- <EventTabs v-if="!isHideNavItems" /> -->
      </div>
      <b-container class="center-container-mobile" fluid>
    <b-row>
      <b-col>
      <div class="centerSection">
        <div>
          <!-- <MobileProfile v-if="isPersonalWall" class="Profile" /> -->
          <MobileCompanyProfile v-if="isCompanyWall" />
          <MobileOtherProfile v-if="isMemberWall" />
        </div>

        <router-view :key="$route.fullPath" />
        <Advertisement
          v-if="!$route.path.includes('messages')"
          :banners="squareBanners"
        />
      </div>
      </b-col>
   </b-row>
    </b-container>
 </div>

 <div v-else>
      <NavbarPersonal />
    <b-container  class="center-container" fluid>
      <b-row  :class="$route.meta.showSidebars ? '' : 'centerSectionFull'">
        <b-col cols="3" v-if="$route.meta.showSidebars">
          <div class="leftSection">
            <Profile
              :isOtherWall="isMemberWall || isCompanyWall"
              class="Profile"
            />
            <OtherCompanyProfile v-if="isCompanyWall" />
            <OtherProfile v-if="isMemberWall" />
            <BookedEvents class="booked-events" />
            <Advertisement
              class="left-Advertisement"
              :imgWidth="'100%'"
              :imgHeight="'auto'"
              :banners="portraitBanners"
            />
          </div>
        </b-col>
        <b-col :cols="$route.meta.showSidebars ? 6 : 12">
          <div class="centerSection">
            <router-view :key="$route.fullPath" />
          </div>
        </b-col>

        <b-col cols="3" v-if="$route.meta.showSidebars">
          <div class="rightSection">
            <Advertisement
              :imgWidth="'100%'"
              :imgHeight="'auto'"
              :banners="squareBanners"
            />
            <PreviousEdition
              v-if="
                (isAwards && award.previous_edition) ||
                (isStandardEvents && event.previous_edition)
              "
            />
            <EventPrices
              v-if="isActivePrices && (isStandardEvents || isAwards)"
              class="event-prices"
            />
            <SponsorCategories
              v-if="isActiveSponsors && (isAwards || isStandardEvents)"
              class="sponsor-categories"
            />
            <UpcomingEvents class="upcoming-events" />
            <LatestCCUpdates class="latest-cc-updates" />
          </div>
        </b-col>
      </b-row>
    </b-container>
</div>
    <FooterPersonal class="footer" v-if="$route.name !== 'currentMessage'" />

    <notifications group="userAlerts" position="bottom left" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Profile from '../components/profile/Profile.vue';
import BookedEvents from '../components/bookedEvents/BookedEvents.vue';
import UpcomingEvents from '../components/upcomingEvents/UpcomingEvents.vue';
import Advertisement from '../components/advertisement/Advertisement.vue';
import LatestCCUpdates from '../components/latesCCupdates/LatesCcUpdates.vue';
import OtherProfile from '../views/profile/OtherProfilePage.vue';

import SponsorCategories from '../components/advertisement/SponsorCategories.vue';
import EventPrices from '../components/advertisement/EventPrices.vue';
import PreviousEdition from '../components/EventList/PreviousEdition.vue';
import ownerId from '../utils/getOwnerId';
import OtherCompanyProfile from '../views/profile/OtherCompanyProfile.vue';

import FooterPersonal from '../components/FooterPersonal.vue';
import NavbarPersonal from '../components/NavbarPersonal.vue';
import MobileNavbar from '../components/mobile/MobileNavbar.vue';
import EventTabs from '../components/mobile/EventTabs.vue';
import MobileProfile from '../components/mobile/MobileProfile.vue';
import MobileCompanyProfile from '../components/mobile/MobileCompanyProfile.vue';
import MobileOtherProfile from '../components/mobile/MobileOtherProfile.vue';

export default {
  name: 'Main',
  data() {
    return {
      isAllEventsPage: false,
      isPastEventsPage: false,
      isStandardEvents: false,
      isGlobalAwardsEvents: false,
      isMeetingPlanner: false,
      isNotifications: false,
      isNetworks: false,
      isMemberWall: false,
      isCompanyWall: false,
      isPersonalWall: true,
      isProfilePage: false,
      squareBanners: [],
      portraitBanners: [],
      mobileBanners: [],
      navbarHeight: '300px',
    };
  },
  components: {
    EventTabs,
    MobileNavbar,
    MobileProfile,
    MobileCompanyProfile,
    MobileOtherProfile,
    NavbarPersonal,
    FooterPersonal,
    Profile,
    BookedEvents,
    UpcomingEvents,
    LatestCCUpdates,
    Advertisement,
    OtherProfile,
    OtherCompanyProfile,
    SponsorCategories,
    EventPrices,
    PreviousEdition,
  },
  computed: {
    ...mapGetters({
      event: 'events/fetchEvent',
      award: 'awards/award',
      isMobileScreen: 'isMobileScreen',
      isHideNavItems: 'core/isHideNavItems',
    }),

    isActiveSponsors() {
      if (this.$route.path.includes('awards')) {
        return this.award && this.award.available_sections
          ? this.award.available_sections.includes('sponsors')
          : false;
      }
      if (this.$route.path.includes('events')  && this.isCurrentRouteNotPublicEventRoutes(this.$route.path)) {
        return this.event && this.event.available_sections
          ? this.event.available_sections.includes('sponsors')
          : false;
      }
      return false;
    },
    isActivePrices() {
      if (this.$route.path.includes('awards')) {
        return this.award && this.award.available_sections
          ? this.award.available_sections.includes('prices')
          : false;
      }
      if (this.$route.path.includes('events') && this.isCurrentRouteNotPublicEventRoutes(this.$route.path)) {
        return this.event && this.event.available_sections
          ? this.event.available_sections.includes('prices')
          : false;
      }
      return false;
    },
  },
  async mounted() {
    if (this.isMobileScreen) {
      await this.fetchAdvertisementBanners('mobile').then(
        res => (this.mobileBanners = res),
      );
    } else {
      await this.fetchAdvertisementBanners('portrait').then(
        res => (this.portraitBanners = res),
      );
      await this.fetchAdvertisementBanners('square').then(
        res => (this.squareBanners = res),
      );
    }
  },
  methods: {
    ...mapActions({
      fetchAdvertisementBanners: 'advertisement/fetchAdvertisementBanners',
      fetchEvent: 'events/fetchEvent',
      fetchAward: 'awards/fetchAward',
      fetchPreviousEdition: 'events/fetchPreviousEdition',
    }),
    async getEvent(id) {
      await this.fetchEvent(id).then(({ previous_edition_info }) => {
        if (previous_edition_info) {
          this.getPreviousEdition(previous_edition_info.id, 'events');
        }
      });
    },
    async getAward(id) {
      await this.fetchAward(id).then(({ previous_edition_info }) => {
        if (previous_edition_info) {
          this.getPreviousEdition(previous_edition_info.id, 'awards');
        }
      });
    },
    async getPreviousEdition(id, type) {
      await this.fetchPreviousEdition({ id, type });
    },
    isCurrentRouteNotPublicEventRoutes(path) {
      return ['/cc-events', '/all-events'].indexOf(path) === -1;
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.isPastEventsPage = val.name === 'pastEvents';
        this.isGlobalAwardsEvents = val.name === 'globalAwardsEvents';
        this.isMeetingPlanner = val.name === 'meetingPlanner';
        this.isNotifications = val.name === 'notification';
        this.isNetworks = val.name === 'network';
        this.isAllEventsPage = val.name === 'ccAllEvents';
        this.isStandardEvents = val.name === 'standardEvent';
        this.isMemberWall = val.name === 'MemberWall'
          && val.params.customerId
          && ownerId !== Number(val.params.customerId);
        this.isCompanyWall = val.name === 'CompanyWall';
        this.isPersonalWall = val.name === 'PersonalWall';
        this.isAllEventsPage = val.name === 'ccAllEvents';
        this.isPastEventsPage = val.name === 'pastEvents';
        this.isStandardEvents = val.path.includes('events') && this.isCurrentRouteNotPublicEventRoutes(val.path);
        this.isAwards = val.path.includes('awards');
        this.isArchivePage = val.path.includes('archive');
        this.isProfilePage = val.path === '/profile';
      },
      immediate: true,
      deep: true,
    },
    '$route.params.eventId': {
      handler(id) {
        if (id) {
          this.getEvent(id);
        }
      },
    },
    '$route.params.awardId': {
      handler(id) {
        if (id) {
          this.getAward(id);
        }
      },
    },
  },
};
</script>
<style>
a {
  text-decoration: none !important;
}
</style>
<style scoped>
@import url(https://fonts.googleapis.com/css?family=Montserrat);
.the-main {
  position: relative;
  min-height: calc(100vh - 6rem);
  padding-bottom: 1rem;
}
.center-container {
  margin-top: 6rem;
  margin-bottom: 8rem;
  max-width: 1600px;
}
.center-container .col-3 {
    -ms-flex: 0 0 20% !important;
    flex: 0 0 20% !important;
    max-width: 20% !important;
}
.center-container .col-6 {
    -ms-flex: 0 0 60% !important;
    flex: 0 0 60% !important;
    max-width: 60% !important;
}
.leftSection,
.rightSection {
  max-width: 100%;
}
.center-container-mobile {
  max-width: 1250px;
  padding: 0 10px !important;
}
.center-container-mobile .row {
  margin: 0 !important;
}
.center-container-mobile .row .col {
  padding: 0 !important;
}
.booked-events,
.left-Advertisement,
.upcoming-events,
.event-prices,
.sponsor-categories,
.latest-cc-updates {
  margin-top: 1rem;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.back {
  background-color: #ebebeb !important;
}
@media print {
  .rightSection,
  .leftSection,
  .footer,
  .for-mobile-banner {
    display: none;
  }
  .centerSection {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .center-container-mobile {
    margin-top: -1rem;
  }
}
@media (max-width: 1024px) {
  .centerSection {
    max-width: 100%;
    flex: 0 0 100%;
    padding-bottom: 100px;
  }
  .for-mobile-banner {
    margin: 1rem 0;
  }
}
</style>
